import { Amplify } from "aws-amplify";
import { ToastContainer, toast } from "react-toastify";
import SnackbarProvider from "react-simple-snackbar";

import "react-toastify/dist/ReactToastify.css";

import { AuthContextProvider } from "hooks/AuthHook";
import { TipSettingsContextProvider } from "hooks/TipSettingsHook";
import { TipPatternsContextProvider } from "hooks/TipPatternsHook";
import { ConnectedDevicesContextProvider } from "hooks/ConnectedDevicesHook";
import { WebsitesContextProvider } from "hooks/WebsitesHook";
import { TipsContextProvider } from "hooks/TipsHook";
import { ChromeExtensionContextProvider } from "hooks/ChromeExtensionHook";
import { WidgetServerContextProvider } from "hooks/WidgetServerHook";
import { WidgetSettingsContextProvider } from "hooks/WidgetSettingsHook";
import { WheelOfFortuneContextProvider } from "hooks/WheelOfFortuneHook";
import { UserSettingsContextProvider } from "hooks/UserSettingsHook";
import { DeviceBatteryContextProvider } from "hooks/DeviceBatteryHook";
import { PageTitleContextProvider } from "hooks/PageTitleHook";
import { KlaviyoContextProvider } from "hooks/KlaviyoHook";
import { ReactComponent as IconCircleError } from "images/i-circle-error.svg";
import { ReactComponent as IconCircleSuccess } from "images/i-circle-success.svg";
import { ReactComponent as IconCircleWarning } from "images/i-circle-warning.svg";
import { ReactComponent as IconClose } from "images/i-close.svg";

import awsconfig from "./aws-exports";

import "./App.scss";
import { WidgetClientContextProvider } from "./hooks/WidgetClientHook";
import Routes from "./routes/Routes";
import { CommunitySharedContextProvider } from "hooks/CommunitySharedHook";

Amplify.configure(awsconfig);

const App = () => {
  return (
    <div id="main">
      <WidgetClientContextProvider>
        <UserSettingsContextProvider>
          <ChromeExtensionContextProvider>
            <ConnectedDevicesContextProvider>
              <PageTitleContextProvider>
                  <DeviceBatteryContextProvider>
                    <WheelOfFortuneContextProvider>
                      <TipSettingsContextProvider>
                        <TipPatternsContextProvider>
                          <WebsitesContextProvider>
                            <TipsContextProvider>
                              <AuthContextProvider>
                                <CommunitySharedContextProvider>
                                  <KlaviyoContextProvider>
                                    <WidgetSettingsContextProvider>
                                      <WidgetServerContextProvider>
                                        <SnackbarProvider>
                                          <Routes />
                                          <ToastContainer
                                            hideProgressBar
                                            draggable
                                            theme="colored"
                                            style={{
                                              width: "fit-content",
                                            }}
                                            closeButton={<IconClose />}
                                            icon={({ type }) => {
                                              switch (type) {
                                                case toast.TYPE.ERROR:
                                                  return <IconCircleError />;
                                                case toast.TYPE.SUCCESS:
                                                  return <IconCircleSuccess />;
                                                case toast.TYPE.WARNING:
                                                case toast.TYPE.INFO:
                                                  return <IconCircleWarning />;
                                              }
                                            }}
                                          />
                                        </SnackbarProvider>
                                      </WidgetServerContextProvider>
                                    </WidgetSettingsContextProvider>
                                  </KlaviyoContextProvider>
                                </CommunitySharedContextProvider>
                              </AuthContextProvider>
                            </TipsContextProvider>
                          </WebsitesContextProvider>
                        </TipPatternsContextProvider>
                      </TipSettingsContextProvider>
                    </WheelOfFortuneContextProvider>
                  </DeviceBatteryContextProvider>
              </PageTitleContextProvider>
            </ConnectedDevicesContextProvider>
          </ChromeExtensionContextProvider>
        </UserSettingsContextProvider>
      </WidgetClientContextProvider>
    </div>
  );
};

export default App;
